"use client";

import { Flex, Heading, IconButton } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/navigation";
import { useCallback, useMemo } from "react";

import { useMarketPlaceProductIdFromUrl } from "@features/marketplace/navigation/useMarketPlaceProductIdFromUrl";
import { useGetMarketPlaceProduct } from "hooks/useGetMarketPlaceProduct";
import { useMarketplaceNavigationEntities } from "hooks/useNavigationEntities";
import RawArrowIcon from "vectors/Arrowhead";

interface Props {
  rightContent?: React.ReactNode;
}
const NavigationTitleAndControls = ({ rightContent }: Props) => {
  const productId = useMarketPlaceProductIdFromUrl();
  const { selectedNavigationEntity } = useMarketplaceNavigationEntities();
  const selectedProduct = useGetMarketPlaceProduct(productId);
  const router = useRouter();

  const handleBack = useCallback(() => {
    if (window.history.length > 2) {
      router.back();
    } else {
      router.push("/");
    }
  }, [router]);

  const name = useMemo(() => {
    if (productId != null) {
      return selectedProduct?.title ?? "";
    }
    return selectedNavigationEntity?.name ?? "";
  }, [selectedProduct, selectedNavigationEntity, productId]);

  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      w="full"
      overflow="hidden"
    >
      <Flex flexDirection="row" alignItems="center" gap={2}>
        {productId != null && (
          <IconButton
            variant="ghost"
            size="sm"
            px={1}
            onClick={handleBack}
            _hover={{
              backgroundColor: "button.secondary.hover",
            }}
          >
            <RawArrowIcon boxSize="10px" direction="left" />
            Back
          </IconButton>
        )}
        <Heading size={{ base: "md", md: "2xl" }} lineClamp={1}>
          {name}
        </Heading>
      </Flex>
      <Flex>{rightContent}</Flex>
    </Flex>
  );
};

export default observer(NavigationTitleAndControls);
